import React, { useState } from "react";
import useTrackWebContext from "../../../hooks/useTrackWebContext";
import { deleteColaborador, putColaborador, activateColaborador } from "../../../utilities/services.js";
import ConfirmModal from "../Modal/ConfirmModal.jsx";
import EditPassword from "../Modal/EditPassword.jsx";
import SuccessModal from "../Modal/SuccessModal.jsx";

const Collaborators = (props) => {
  const { nombre_completo, nro_documento, email, id, estado, update } = props;
  const { token } = useTrackWebContext();

  const [showAlert, setShowAlert] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [success, setSuccess] = useState(""); 

  const handleDelete = async () => {
    try {
      await deleteColaborador({ id, token });
      setSuccess("Colaborador eliminado correctamente");
      setShowAlert(false);
      update();
    } catch (error) {
      console.error("Error eliminando colaborador:", error);
    }
  };

  const handleActivate = async () => {
    try {
      await activateColaborador({ id, token });
      setSuccess("Colaborador activado correctamente");
      setShowAlert(false);
      update();
    } catch (error) {
      console.error("Error activando colaborador:", error);
    }
  };

  const handlePut = async (password) => {
    try {
      await putColaborador({ id, pwd: password, token });
      setSuccess("Contraseña editada correctamente");
      setEditPassword(false);
    } catch (error) {
      console.error("Error editando colaborador:", error);
    }
  };

  const isActive = estado === "activo";
  const buttonLabel = isActive ? "Eliminar" : "Activar";
  const confirmMessage = isActive
    ? `Vas a eliminar al colaborador/a ${nombre_completo}`
    : `Vas a activar al colaborador/a ${nombre_completo}`;
  const confirmAction = isActive ? handleDelete : handleActivate;
  const capitalizeFirst = (s) =>
  s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "";

  return (
    <>
      <tbody className="leading-5">
        <tr className="text-left text-gray-700 border-b bg-white">
          {/* Colaborador */}
          <td className="p-2">{nombre_completo}</td>

          {/* DNI */}
          <td className="p-2">{nro_documento}</td>

          {/* Email */}
          <td className="p-2">{email}</td>

          {/* Botón de cambiar contraseña */}
          <td className="p-2 text-center">
            <button
              onClick={() => setEditPassword(true)}
              className="btn bg-clvblue text-white rounded-full h-8 px-3 pb-[2px]"
            >
              Cambiar contraseña
            </button>
          </td>

          {/* Botón de quitar/activar colaborador */}
          <td className="p-2 text-center">
            <button
              onClick={() => setShowAlert(true)}
              className="btn bg-clvblue text-white rounded-full h-8 px-3 pb-[2px]"
            >
              {buttonLabel}
            </button>
          </td>
          <td className="p-2 lowercase first-letter:uppercase">{capitalizeFirst(estado)}</td>
        </tr>
      </tbody>

      {editPassword && (
        <EditPassword
          onConfirm={handlePut}
          onCancel={() => setEditPassword(false)}
        />
      )}

      {/* Modal de confirmación */}
      {showAlert && (
        <ConfirmModal
          message={confirmMessage}
          onConfirm={confirmAction}
          onCancel={() => setShowAlert(false)}
          button={buttonLabel}
        />
      )}

      {/* Modal de éxito genérico */}
      {success && (
        <SuccessModal
          message={success}
          onClose={() => setSuccess("")} 
        />
      )}
    </>
  );
};

export default Collaborators;
